import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'

import { useUserStore } from 'Stores/userStoreModuleFed'

export interface DomianTypeAndProducts {
  id: number
  botZapping?: boolean
  paidMarketing?: boolean
  wordpress: boolean
}

type Body = Array<DomianTypeAndProducts>

const updateDomainsStatus = async (body: Body) => {
  const accountId = useUserStore.getState().accountId
  return await request({
    method: 'PATCH',
    url: `accounts/${accountId}/domains/products`,
    data: body,
  })
}

export const useUpdateDomainsStatus = () => {
  const queryClient = useQueryClient()
  const { mutate, mutateAsync, isLoading, isError, error } = useMutation(updateDomainsStatus, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['domains'])
    },
  })

  return { mutate, isLoading, isError, error, mutateAsync }
}
